angular.module("vgresiduos").controller("CreateAuditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/fornecedores/${$stateParams.supplierCode}/auditoria`);
		};
	}
]);
